import { useContext, useEffect, useState } from "react";
import { usePointingBoardingOtherStore } from "../../../../store/PointingStore";
import { OperationContext } from "../../CreateOperation";
import { useSearchParams } from "react-router";
import { ColumnItem } from "../../../../../../common/models/table";
import { PointingService } from "../../../../core/_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../../../common/components/Loader/Loader";
import { LFTableV2 } from "../../../../../../common/components/LFTable/LFTableV2";
import { useOperationType } from "../../../../core/_context";
import { LFTableV3 } from "../../../../../../common/components/LFTable/LFTableV3";
import { ActionsKey } from "../../../../../../common/models/Actions";
import { CustomDrawer } from "../../../../../../common/components/Drawer/CustomDrawer";
import { OtherDetails } from "../details/otherDetails/OtherDetails";

export const BoardingOtherPointingList = () => {
  const { initialValue } = useContext(OperationContext);

  const {
    list,
    pageState,
    totalItems,
    setList,
    resetPageState,
    setPageState,
    setActioned,
    resetList,
    actioned,
  } = usePointingBoardingOtherStore();
  const [searchParams] = useSearchParams();
  const movement = searchParams.get("movment");
  const type = searchParams.get("type");

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isShowDrawer, setIsShowDrawer] = useState<boolean>(false);

  const operationType = useOperationType();

  const cols: ColumnItem[] = [
    {
      key: "label",
      title: "Désignation",
      dataIndex: "label",
      searchKey: "uniqueIdentifier",
      searchType: "text",
      show: true,
      // isCanSort: true,
    },
    {
      key: "description",
      title: "Description",
      dataIndex: "description",
      show: true,
      // isCanSort: true,
    },
    {
      key: "tonnage",
      title: "Tonnage (T)",
      dataIndex: "tonnage",
      show: true,
      // isCanSort: true,
    },
    ...(operationType === "sales"
      ? [
          {
            key: "inspectionStoragePeriod",
            title: "Pointage entreposage",
            dataIndex: "inspectionStoragePeriod",
            searchType: "date",
            searchKey: "inspectionStorageStartAt",
            show: true,
            isCanSort: true,
            sortKey: "inspectionStorageStartAt",
            defaultSort: "desc"
          } as ColumnItem,
        ]
      : []),
      {
        key: "inspectionDocksidePeriod",
        title: "Pointage à Quai",
        dataIndex: "inspectionDocksidePeriod",
        show: true,
        searchType: "date",
        searchKey: "inspectionDocksideStartAt",
        isCanSort: true,
        sortKey: "inspectionDocksideStartAt",
        defaultSort: operationType === "cabotage" ? "desc" : null,
      },
      ...(operationType === "sales"
        ? [
            // {
            //   key: "inspectionOnBoardPeriod",
            //   title: "Inspection à Bord",
            //   dataIndex: "inspectionOnBoardPeriod",
            //   show: true,
            //   // isCanSort: true,
            // } as ColumnItem,
            {
              key: "inspectionOnBoardPeriod",
              title: "Pointage à Bord",
              dataIndex: "inspectionOnBoardPeriod",
              show: true,
              searchType: "date",
              searchKey: "inspectionOnBoardStartAt",
              isCanSort: true,
              sortKey: "inspectionOnBoardStartAt",
            } as ColumnItem,
          ]
        : []),
  ];

  useEffect(() => {
    resetPageState();
  }, [movement, type]);

  useEffect(() => {
    const selected =
      initialValue?.embarkationMovement?.loadPossessionStatus?.find(
        (item: any) => item.id === type?.toUpperCase()
      ) ?? initialValue?.embarkationMovement?.loadPossessionStatus?.[0];

    if (selected && selected?.url && movement) {
      const hasOrder = (() => {
        if (pageState?.order?.dataKey && pageState?.order?.order) {
          return true;
        }
  
        return Object.entries(pageState).some(
          ([key, value]) =>
            key.startsWith("order[") &&
            value !== null &&
            value !== undefined &&
            value !== ""
        );
      })();
  
      if (!hasOrder && !pageState?.__defaultOrderSet) {
        if (operationType === "sales") {
          setPageState({
            ...pageState,
            order: {
              inspectionStorageStartAt: "desc",
            },
            __defaultOrderSet: true,
          });
        } else {
          setPageState({
            ...pageState,
            order: {
              inspectionDocksideStartAt: "desc",
            },
            __defaultOrderSet: true,
          });
        }
        return;
      }

      getMovement(`${selected?.url}/controlled`, {
        ...pageState,
        "movement.id": movement,
        isLoadControlled: true,
      });
    }
  }, [movement, pageState, type]);

  const getMovement = async (url: string, params: any) => {
    try {
      setIsLoading(true);
      params?.page == 1 && resetList();

      const res = await PointingService.getAllMouvement(url, params);

      if (res?.status === HttpStatusCode.Ok) {
        setList(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onActionClick = (item: any, action: ActionsKey) => {
    if (action === "delete") {
      // onDeleteHandler(item?.id);
    } else {
      handleShowDrawer();
      setActioned({
        data: item,
        action,
      });
    }
  };
  const handleShowDrawer = () => {
    setIsShowDrawer((prev: boolean) => !prev);
  };

  return (
    <div>
      <Loader isLoading={isLoading} />
      <LFTableV3
        columns={cols}
        data={list}
        params={pageState}
        onAction={onActionClick}
        isCanShow={() => true}
        onSearch={setPageState}
        onSort={setPageState}
        onResetSearch={resetPageState}
        pagination={{
          defaultCurrentPage: pageState.page,
          itemsPerPage: pageState?.itemsPerPage,
          totalItems: totalItems,
        }}
        onChangePage={setPageState}
      />
      {isShowDrawer && (
        <CustomDrawer
          isOpen={isShowDrawer}
          onClose={handleShowDrawer}
          title={`${actioned?.action === "read" ? "Détails" : "Modification"}`}
        >
          <OtherDetails initialValue={actioned?.data} />
        </CustomDrawer>
      )}
    </div>
  );
};
